import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  connected: false,
  username: null,
  avatar_url: null,
  repo_count: 0,
  last_commit: null,
  last_validated: null,
  token: '',
  status: 'idle',
  loading: false,
  error: null,
  message: null,
  commitSettings: {
    commits_per_day: 1,
    random_commits: false,
  },
  streakProgress: {
    current_streak: 0,
    streak_goal: 30,
    streak_percentage: 0,
    commits_made: 0,
    days_remaining: 30,
    recent_activity: [],
    streak_status: "inactive",
    longest_streak: 0,
  },
};

const githubSlice = createSlice({
  name: 'github',
  initialState,
  reducers: {
    // Enhanced GitHub connection state management
    setGithubConnected: (state, action) => {
      const { connected, username, avatar_url, last_validated, message } = action.payload;
      state.connected = connected;
      state.username = username;
      state.avatar_url = avatar_url;
      state.last_validated = last_validated;
      state.message = message;
      state.error = null;
      state.status = connected ? 'connected' : 'disconnected';
    },
    
    // Update comprehensive GitHub status
    setGithubStatus: (state, action) => {
      const { connected, username, repo_count, last_commit, avatar_url, last_validated, message, ...rest } = action.payload;
      state.connected = connected ?? state.connected;
      state.username = username || state.username;
      state.avatar_url = avatar_url || state.avatar_url;
      state.repo_count = repo_count ?? state.repo_count;
      state.last_commit = last_commit || state.last_commit;
      state.last_validated = last_validated || state.last_validated;
      state.message = message || state.message;
      Object.assign(state, rest);
      state.error = null;
      state.status = connected ? 'connected' : 'disconnected';
    },
    
    // Loading state management
    setGithubLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // Error state management
    setGithubError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.status = 'error';
    },
    
    // Token management
    setGithubToken: (state, action) => {
      state.token = action.payload;
    },
    
    // Settings management
    setCommitSettings: (state, action) => {
      state.commitSettings = { ...state.commitSettings, ...action.payload };
    },
    
    // Progress management
    setStreakProgress: (state, action) => {
      state.streakProgress = { ...state.streakProgress, ...action.payload };
    },
    
    // Clear all GitHub data
    clearGithub: (state) => {
      return { ...initialState };
    },
    
    // Reset error state
    clearGithubError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setGithubConnected,
  setGithubStatus,
  setGithubLoading,
  setGithubError,
  setGithubToken,
  setCommitSettings,
  setStreakProgress,
  clearGithub,
  clearGithubError,
} = githubSlice.actions;

export default githubSlice.reducer;